import React from "react";
import { Checkbox, ControlLabel } from "react-bootstrap";
import locale from "../../../../../locale";

const HallDescriptionBlockSettings = ({$locale, blockProperties, streams, onSave, onSaveStreams}) => {
    return (
        <>
            <Checkbox
                checked={blockProperties?.showModal ?? true}
                onChange={(e) => onSave({showModal: e.target.checked})}
            >
                {locale('program.modals.show')}
            </Checkbox>
            <Checkbox
                checked={blockProperties?.showBlockExpanded ?? true}
                onChange={(e) => onSave({showBlockExpanded: e.target.checked})}
            >
                {locale('settings.show.block.expanded')}
            </Checkbox>
            <hr />
            {
                !!streams.length &&
                <>
                    <ControlLabel>{locale('settings.show.block.displayHall')}</ControlLabel>
                    {
                        streams.map((stream) => (
                            <Checkbox
                                key={stream.id}
                                style={{marginTop: 0}}
                                value={stream.id}
                                checked={blockProperties?.showInStreams?.includes(stream.id) || false}
                                onChange={(e) => onSaveStreams(stream.id, e.target.checked)}
                            >
                                {stream[`description_${$locale.localeName}`]}
                            </Checkbox>
                        ))
                    }
                </>
            }
        </>
    );
};

export default HallDescriptionBlockSettings;
